export default __webpack_public_path__ + "static/media/shipCalmIcon.98732fd5.svg";